import React from "react";
import SinglePortfolio from "./SinglePortfolio";
import arogga from "../../../../images/arogga-pic.png";
import domic from "../../../../images/domic.png";
import trello from "../../../../images/trello-app-pic.png";
import todo from "../../../../images/todo-app-pic.png";
import IC from "../../../../images/interactive-cares.png";
import rou from "../../../../images/rou.png";
import harri from "../../../../images/Harri.png";
import creative from "../../../../images/creative-campus.png";
import amaito from "../../../../images/amaitoSoft.png";
import qbit from "../../../../images/qbit.png";
import rabbit from "../../../../images/rabbit.png";
import activeit from "../../../../images/activeit.png";

const webSiteData = [
  {
    id: 1,
    name: "QuadBit Technologies",
    url: "https://quadbittech.com/",
    img: qbit,
    github: "https://github.com/Mahmud-cf/QuadBit-Technologies",
  },
  {
    id: 2,
    name: "Amaito Soft",
    url: "https://amaitosoft.com/",
    img: amaito,
    github: "https://github.com/Mahmud-cf/Amaito_website",
  },
  {
    id: 3,
    name: "Little Rabbit",
    url: "https://littlerabbitproject.com/",
    img: rabbit,
    github: "https://github.com/Mahmud-cf/Little_Rabbit_Project",
  },
  {
    id: 4,
    name: "Full Ecommerce Application",
    url: "https://harri-ecommerce.netlify.app/",
    img: harri,
    github: "https://github.com/Mahmud-cf/Harri-Ecommerce",
  },
  {
    id: 5,
    name: "Active IT",
    url: "https://111activeit.com/",
    img: activeit,
    github: "",
  },
  {
    id: 6,
    name: "Creative Campus",
    url: "https://creative-campus.netlify.app/",
    img: creative,
    github: "https://github.com/Mahmud-cf/Creative-Campus-Website",
  },
  {
    id: 7,
    name: "Trello App",
    url: "https://trello-app-cf.netlify.app",
    img: trello,
    github: "https://github.com/Mahmud-cf/Trello-App",
  },
  {
    id: 8,
    name: "Domic",
    url: "https://domic.netlify.app/",
    img: domic,
    github: "https://github.com/Mahmud-cf/Docmic",
  },
  {
    id: 9,
    name: "Interactive Cares Website",
    url: "https://shimmering-mandazi-e360b6.netlify.app",
    img: IC,
    github: "",
  },
];

function Portfolio() {
  return (
    <div className="container-fluid" id="Portfolio">
      <div className="container">
        <div className="section-padding">
          <div
            data-aos="fade-up"
            data-aos-duration="800"
            className="my-info-wrapper text-center portfolio-title"
          >
            <p>Portfolio</p>
            <h2>I Love What I Do</h2>
          </div>
          <div className="row">
            {/* <div className="col-lg-4 col-sm-6">
              <div className="single-portfolio">
                <SinglePortfolio
                  img={qbit}
                  name="QuadBit Technologies"
                  url="https://quadbittech.com/"
                  github="https://github.com/Mahmud-cf/QuadBit-Technologies"
                />
              </div>
            </div> */}
            {webSiteData.map((item) => {
              return (
                <div className="col-lg-4 col-sm-6" id={item.id}>
                  <div className="single-portfolio">
                    <SinglePortfolio
                      img={item.img}
                      name={item.name}
                      url={item.url}
                      github={item.github}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
